import React from "react";

const STYLES = {
  pending: {
    dot: "bg-gray-500",
    text: "text-gray-700",
    ring: "ring-gray-300",
  },
  approved: {
    dot: "bg-green-500",
    text: "text-gray-800",
    ring: "ring-gray-300",
  },
  rejected: {
    dot: "bg-red-500",
    text: "text-gray-800",
    ring: "ring-gray-300",
  },
};

export function Badge({
  label,
  variant = "pending",
  className = "",
  size = "sm", // "sm" | "md"
}) {
  const styles = STYLES[variant] ?? STYLES.pending;

  const SIZES = {
    sm: {
      wrapper: "px-2 py-1 text-xs rounded-lg",
      dot: "h-2 w-2",
      gap: "gap-1.5",
    },
    md: {
      wrapper: "px-4 py-2 text-sm rounded-xl",
      dot: "h-3 w-3",
      gap: "gap-2",
    },
  };

  const s = SIZES[size];

  return (
    <span
      className={[
        "inline-flex items-center font-normal bg-white ring-1 ring-inset shadow-sm",
        styles.text,
        styles.ring,
        s.wrapper,
        s.gap,
        className,
      ].join(" ")}
    >
      <span
        className={`rounded-full ${styles.dot} ${s.dot}`}
        aria-hidden="true"
      />
      {label}
    </span>
  );
}